var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.172,
    height: 30.2,
    viewBox: "0 0 30.172 30.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(-1.9 -1.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    d: "M13.67-1.1A14.77,14.77,0,0,1,28.44,13.67,14.77,14.77,0,0,1,3.226,24.114a14.77,14.77,0,0,1,0-20.888A14.673,14.673,0,0,1,13.67-1.1Zm0,27.34A12.57,12.57,0,0,0,22.558,4.782,12.57,12.57,0,1,0,4.782,22.558,12.488,12.488,0,0,0,13.67,26.24Z",
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M4.648,5.776a1.1,1.1,0,0,1-.78-.325L-.78.775a1.1,1.1,0,0,1,0-1.556,1.1,1.1,0,0,1,1.556,0L5.428,3.9a1.1,1.1,0,0,1-.78,1.875Z",
    transform: "translate(26.324 26.324)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.99c94c298acdb30664aeeee11906ec03.svg";
export { ForwardRef as ReactComponent };